import React, { useState, useEffect } from "react";
import { Table, Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Tooltip from "@mui/material/Tooltip";
import PurchaseOrderForm from "./PurchaseOrderForm";

function PurchaseOrderLog(props) {
  const [modalLoading, setModalLoading] = useState(true);
  const [PurchaseOrderRowdata, SetPurchaseOrderRowdata] = useState([]);
  const [PurchaseOrderHeaders, setPurchaseOrderHeaders] = useState([]);
  const [AddPurchaseOrderDisable, setAddPurchaseOrderDisable] = useState(false);

  const fetchRowDetails = async () => {
    setModalLoading(true);
    let obj = {
      query: `[dbo].[CRM_Proc_PurchaseOrder_GetList] @agentID='{0}', @EnquiryID='{1}'`,
      queryArr: [`${props.AgentID}`, `${props.enquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);

      // ✅ Always set this, regardless of whether rows exist
      setAddPurchaseOrderDisable(
        Number(resp["config"]?.[0]?.["adddisable"]) === 1,
      );

      if (resp[""].length > 0) {
        SetPurchaseOrderRowdata(resp[""]);
        setPurchaseOrderHeaders(Object.keys(resp[""][0]));
      } else {
        SetPurchaseOrderRowdata([]);
        setPurchaseOrderHeaders([]);
      }
    } catch (err) {
      console.error("Error fetching purchase order details:", err);
    } finally {
      setModalLoading(false);
    }
  };

  useEffect(() => {
    if (props.isOpen) {
      fetchRowDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  const renderCell = (col, row, rowIndex) => {
    const value = row[col];
    let displayValue = "";

    if (value && typeof value === "object" && value.date) {
      displayValue = new Date(value.date).toLocaleDateString("en-IN");
    } else if (value instanceof Date) {
      displayValue = value.toLocaleDateString("en-IN");
    } else {
      displayValue = String(value ?? "");
    }

    return (
      <td key={col} style={{ textAlign: "center" }}>
        {displayValue}
      </td>
    );
  };

  return (
    <>
      <Tooltip title="Purchase Order">
        <ReceiptLongIcon
          style={{ cursor: "pointer", fontSize: "25px" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onOpen?.();
          }}
        />
      </Tooltip>

      <Modal
        show={props.isOpen}
        onHide={() => props.onClose?.()}
        dialogClassName="custom-modal"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ backgroundColor: "#f5f9ff" }}>
          <div className="w-100">
            <div>
              <strong>Purchase Order Log</strong>
            </div>
            <div className="d-flex gap-4 mt-2">
              <span>
                <strong>EnquiryID:</strong> {props.enquiryID}
              </span>
              <span>
                <strong>CustomerName:</strong> {props.customerName}
              </span>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {!modalLoading && (
              <div style={{ cursor: "pointer", marginRight: "10px" }}>
                <PurchaseOrderForm
                  AgentID={props.AgentID}
                  enquiryID={props.enquiryID}
                  customerName={props.customerName}
                  RefreshLogs={() => fetchRowDetails()}
                  disabled={AddPurchaseOrderDisable}
                />
              </div>
            )}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => props.onClose?.()}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "85vh", overflowY: "auto" }}>
          {!modalLoading ? (
            PurchaseOrderRowdata.length > 0 ? (
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Table
                  striped
                  className="custom-table w-100"
                  size="sm"
                  style={{ borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      {PurchaseOrderHeaders.map((s, index) => (
                        <th
                          key={index}
                          style={{
                            background: "#000",
                            color: "white",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          {s.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                    {PurchaseOrderRowdata.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {PurchaseOrderHeaders.map((col) =>
                          renderCell(col, row, rowIndex),
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <span>No Records!</span>
              </div>
            )
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PurchaseOrderLog;
